import HeaderComp from "../header/header_comp";
import FooterComponent from "../footer/footer_component";
import "./style/page_style.css";

const PageComponent = ({ content, showFooter = true }) => {
    return (
        <div class="w-full relative">
            <div class="w-full absolute">
                <HeaderComp />
            </div>
            <div class={`${showFooter === true ? "page-content-width-header-and-footer" : "page-content-with-header"} flex flex-column`}>
                {content}
            </div>
            {showFooter === true ? <FooterComponent /> : <div />}
        </div>
    );
};

export default PageComponent;